// eslint-disable-next-line no-restricted-imports
import { SegmentedControl } from '@workday/canvas-kit-preview-react/segmented-control';
import { ButtonColors } from '@workday/canvas-kit-react/button';
import { createComponent } from '@workday/canvas-kit-react/common';
import { WcpStyles } from '@workday/wcp-tokens';
import React, { Ref } from 'react';

// TODO: WCPX-13168 WcpStyles icon colors values need to be updated
const getIconButtonColors = (toggled?: boolean): ButtonColors => ({
  default: {
    background: toggled ? WcpStyles.color.bg.default : WcpStyles.color.bg.alt.soft,
    border: toggled ? WcpStyles.color.border.input.default : 'transparent',
    icon: WcpStyles.color.icon.strong,
    label: toggled ? WcpStyles.color.text.strong : WcpStyles.color.text.hint,
  },
  hover: {
    background: toggled ? WcpStyles.color.bg.default : WcpStyles.color.bg.alt.strong,
    border: toggled ? WcpStyles.color.border.input.default : 'transparent',
    icon: WcpStyles.color.icon.strong,
    label: WcpStyles.color.text.hint,
  },
  active: {
    background: toggled ? WcpStyles.color.bg.default : WcpStyles.color.bg.alt.strong,
    border: toggled ? WcpStyles.color.border.input.default : 'transparent',
    icon: WcpStyles.color.icon.strong,
    label: WcpStyles.color.text.hint,
  },
  focus: {
    background: toggled ? WcpStyles.color.bg.default : WcpStyles.color.bg.alt.soft,
    border: toggled ? WcpStyles.color.border.input.default : 'transparent',
    icon: WcpStyles.color.icon.strong,
    label: toggled ? WcpStyles.color.text.strong : WcpStyles.color.text.hint,
  },
  disabled: {
    background: WcpStyles.color.bg.alt.soft,
    opacity: '1',
    icon: WcpStyles.color.icon.strong,
    border: toggled ? WcpStyles.color.border.input.default : 'transparent',
    label: WcpStyles.color.text.strong,
  },
});

interface SegmentedControlProps {
  toggled?: boolean;
}

// Add a new prop... maybe toggled or active!? Which is a state on click?
export const ThemedSegmentedControlItem = createComponent('button')({
  Component: (
    { toggled, ...props }: React.ComponentProps<typeof SegmentedControl.Item> & SegmentedControlProps,
    ref: Ref<HTMLButtonElement>,
    Element
  ) => <SegmentedControl.Item ref={ref} as={Element} colors={getIconButtonColors(toggled)} {...props} />,
});

export const ThemedSegmentedControlList = createComponent('div')({
  Component: (props: React.ComponentProps<typeof SegmentedControl.List>, ref: Ref<HTMLDivElement>, Element) => (
    <SegmentedControl.List
      ref={ref}
      as={Element}
      {...props}
      backgroundColor={WcpStyles.color.bg.alt.soft}
      borderColor={WcpStyles.color.border.input.default}
    />
  ),
});

export const ThemedSegmentedControl = (props: React.ComponentProps<typeof SegmentedControl>) => (
  <SegmentedControl {...props} />
);

ThemedSegmentedControl.List = ThemedSegmentedControlList;
ThemedSegmentedControl.Item = ThemedSegmentedControlItem;
